const handlebars: any = require('handlebars-template-loader/runtime');

handlebars.registerHelper('isTrue', function<T>(this: any, variable: T, options: any) {
    return variable ? options.fn(this) : options.inverse(this);
});
